import React, { useState, useEffect } from "react";
import axios from "axios";
import { ItemListResponse } from "helpers/interfaces";

interface IContext {
    statuses: ITicketStatus[]
    isLoading: boolean
    
    getStatuses: () => void
    deleteTicketStatus: (StateId: string) => Promise<void>
}

export interface ITicketStatus {
    code: string
    name: string
    customerVisibleStatus: string
    id: string
    isInitialStatus: boolean
    isResolved: boolean
    hasAutomaticUpdates: boolean
}

export let ticketStatusesContext = React.createContext<IContext>({} as IContext);

let { Provider } = ticketStatusesContext;

let TicketStatesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let [isLoading, setLoading] = useState(true);
    let [statuses, setStatuses] = useState<ITicketStatus[]>([]);


    useEffect(() => {
        getStatuses()
    }, [])


    let getStatuses = async () => {
        try {
            setLoading(true);

            let response = await axios.get<ItemListResponse<ITicketStatus>>('/api/TicketStatus/GetTicketStatuses');
            setStatuses(response.data.items);

        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    let deleteTicketStatus = async (categoryId: string) => {
        if (window.confirm("Are you sure that you want to remove this ticket Status?")) {
            try {
                await axios.delete(`/api/TicketStatus/DeleteTicketStatus/${categoryId}`);
                setStatuses(statuses.filter(category => category.name !== categoryId));
                getStatuses()

            } catch (err) { }
        }
    }


    return (
        <Provider value={{
            statuses,
            isLoading,

            getStatuses,
            deleteTicketStatus
        }}>
            {children}
        </Provider>
    );
};

export default TicketStatesProvider